const navigation = {
  dashboard: "Dashboards",
  knowledge: "Conhecimento",
  agents: "Agentes",
  playground: "Playground",
  database: "Banco de Dados",
  integrations: "Integrações",
  dataSources: "Fontes de Dados",
  profile: "Perfil",
  settings: "Configurações",
  generalSettings: "Configurações Gerais",
  workspaceSettings: "Configurações do Workspace",
  selectWorkspace: "Selecione o Workspace",
  emptyWorkspacesMessage: "Cadastre um Workspace para ver as opções disponíveis",
  selectOrganization: "Selecionar organização",
  orgHint: {
    title: "Você entrou em {{organization}}",
    message: "Alterne de organização aqui.",
  },
  platformView: "SUPERADMIN",
  organizationView: "Visão da organização",
  backToOrganization: "Voltar para organização",
  superadminOnlyTitle: "Área exclusiva da Visão Superadmin",
  superadminOnlyDescription: "Esta área só está disponível quando nenhuma organização está selecionada.",
  backToPlatform: "Voltar para Visão Superadmin",
  goToDashboard: "Ir para o Dashboard",
  account: "Conta",
  logout: "Sair",
  workspaceGroup: "Workspace",
  toggleSidebar: "Expandir/recolher menu"
} as const;

export default navigation;
